'use client';
import type { CSSProperties } from 'react';
import { motion } from 'framer-motion';
import { Ccontainer } from '@/components/ui/Ccontainer';
import { Cmarkdown } from '@/components/ui/Cmarkdown';
import { Ctext } from '@/components/ui/Ctext';
import { ColorType, FontWeight, getFontFamily } from '@/theme';
import type { WitnessCardData } from '@/components/ui/Cwitnesscard';
import { CWITNESSCARDMODAL_EASE_CURVE } from './cwitnesscardmodalConstants';
import { CWITNESSCARDMODAL_CONTENT_INNER_STYLE, getCwitnesscardmodalContentContainerStyle, } from './cwitnesscardmodalStyles';
const WITNESS_CARD_MODAL_EXTRA_DESCRIPTION_STYLE: CSSProperties = { opacity: 0.8 };
interface CwitnesscardmodalContentPanelProps {
    card: WitnessCardData;
    isMobile: boolean;
}
export function CwitnesscardmodalContentPanel({ card, isMobile, }: CwitnesscardmodalContentPanelProps) {
    return <Ccontainer rootAttributes={{ "data-el": "Cwitnesscardmodal/ContentPanel/Root" }} style={getCwitnesscardmodalContentContainerStyle(isMobile)} backgroundColor={ColorType.Black} backgroundOpacity={0.95} display="flex" flexDirection="column" justifyContent="center">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.4, ease: CWITNESSCARDMODAL_EASE_CURVE }} style={CWITNESSCARDMODAL_CONTENT_INNER_STYLE}>
                <Ctext size={32} weight={FontWeight.Bold} color={ColorType.Accent} style={{ fontFamily: getFontFamily(), letterSpacing: '-0.02em' }}>
                    {card.title}
                </Ctext>
                <Ctext size={20} weight={FontWeight.Medium} color={ColorType.White} style={{ lineHeight: 1.6 }}>
                    {card.description}
                </Ctext>
                <Ccontainer rootAttributes={{ "data-el": "Cwitnesscardmodal/ContentPanel/Divider" }} backgroundColor={ColorType.Accent} backgroundOpacity={0.25} width="100%" height={1} padding={0}/>
                <Cmarkdown dataElScope="Cwitnesscardmodal/ContentPanel" content={card.extraDescription} textSize={17.6} textWeight={FontWeight.Regular} style={WITNESS_CARD_MODAL_EXTRA_DESCRIPTION_STYLE}/>
            </motion.div>
        </Ccontainer>
        ;
}
